import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ModalController, IonicModule} from '@ionic/angular';
import {OverviewType} from '../../../domain/overview-type';
import {FormsModule} from '@angular/forms';
import {PositionOverviewComponent} from './position-overview/position-overview.component';
import {SettlementOverviewComponent} from './settlement-overview/settlement-overview.component';
import {TranslateModule} from '@ngx-translate/core';

// SwiperCore.use([Pagination]);

@Component({
  selector: 'app-insights-modal',
  imports: [IonicModule, FormsModule, PositionOverviewComponent, SettlementOverviewComponent, TranslateModule],
  templateUrl: './insights-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./insights-modal.component.scss']
})
export class InsightsModalComponent implements OnInit {
  public readonly OverviewType = OverviewType;

  public selectedOverview: string;

  constructor(private readonly modalController: ModalController) {
  }

  dismiss(): void {
    this.modalController.dismiss().then();
  }

  ngOnInit(): void {
    this.selectedOverview = OverviewType.SETTLEMENT_OVERVIEW;
  }
}
